if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('pointerup', this.onBackdropPointerUp.bind(this));
    }

    // MOONSYL_PRODUCT_MODAL_BACKDROP_CLOSE_20260617
    onBackdropPointerUp(event) {
      if (!this.hasAttribute('open')) return;
      if (event.button && event.button !== 0) return;
      if (event.target.closest('.product-media-modal__toggle')) return;

      const mediaTarget = event.target.closest(
        '.product-media-modal__content img, .product-media-modal__content video, .product-media-modal__content iframe, .product-media-modal__content model-viewer, .product-media-modal__content deferred-media, .product-media-modal__content product-model'
      );

      if (mediaTarget) return;

      this.hide();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
